import { handleActions } from "redux-actions";
import { MERCHANT_ENABLEMENTS } from "constants/action-types";
import { TMerchantEnablements } from "models/new";

interface IState {
    hasMerchantEnablementsErrored?: boolean;
    isFetchingMerchantEnablements: boolean;
    merchantEnablements: TMerchantEnablements;
}

const initialState: IState = {
    hasMerchantEnablementsErrored: undefined,
    isFetchingMerchantEnablements: false,
    merchantEnablements: [],
};

export const merchantEnablements = handleActions(
    {
        [MERCHANT_ENABLEMENTS.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetchingMerchantEnablements: true,
                merchantEnablements: [],
            };
        },
        [MERCHANT_ENABLEMENTS.FETCH.SUCCESS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                isFetchingMerchantEnablements: false,
                merchantEnablements: payload,
            };
        },
        [MERCHANT_ENABLEMENTS.FETCH.ERROR]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                isFetchingMerchantEnablements: false,
                hasMerchantEnablementsErrored: true,
                merchantEnablements: [],
            };
        },
    },
    initialState
);
